<template>
  <div class="project-app-wrapper">
    <div class="left" :class="getClass()">
      <Sidebar
        v-show="
          root.$route.path.indexOf('/wayline-edit-planar') === -1 &&
          root.$route.path.indexOf('/wayline-edit') === -1 &&
          root.$route.path.indexOf('/wayline-edit-planar') === -1
        "
      />
      <!--左侧图标栏-->
      <div
        class="main-content uranus-scrollbar dark"
        :class="getClass()"
        :style="getStyle()"
      >
        <!--中间内容-->
        <router-view />
      </div>
      <div
        class="menu-icon"
        @click="handleChangeCollapsed"
        v-if="showHeader"
        v-show="
          root.$route.path.indexOf('/wayline-edit-planar') === -1 &&
          root.$route.path.indexOf('/wayline-edit') === -1 &&
          root.$route.path.indexOf('/wayline-edit-planar') === -1
        "
      >
        <CaretLeftOutlined v-if="collapsed" />
        <CaretRightOutlined v-else />
      </div>
    </div>
    <div class="right">
      <!-- <div class="map-wrapper"> -->
      <!-- <GMap />  -->
      <!--地图 @update-fly-point-list="printAllPoints" @update-fly-point="updatePoint"-->
      <!-- </div> -->
      <div
        class="media-wrapper"
        v-if="root.$route.path === '/'+ERouterName.MEDIA"
      >
        <MediaPanel />
      </div>
      <div
        class="task-wrapper"
        v-if="root.$route.path === '/'+ERouterName.TASK"
      >
        <TaskPanel />
        <!--任务计划-->
      </div>
      <div
        class="device-wrapper"
        v-if="root.$route.path === '/'+ERouterName.DEVICES"
      >
        <Devices />
        <!--设备管理-->
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import Sidebar from '/@/components/common/sidebar.vue'
import MediaPanel from '/@/components/MediaPanel.vue'
import TaskPanel from '/@/components/task/task-panel.vue'
import Devices from '/@/pages/page-web/projects/devices.vue'
// import GMap from '/@/components/CesiumMap.vue'
import { ERouterName } from '/@/types'
import { getRoot } from '/@/root'
import { useMyStore } from '/@/store'
import { useConnectWebSocket } from '/@/hooks/use-connect-websocket'
import {
  handleMessage,
  initMessageHandler,
} from '/@/utils/websocket-message-handler'
import { computed } from 'vue'

const root = getRoot()
const store = useMyStore()
const collapsed = computed(() => store.state.collapsed)
const showHeader = computed(() => {
  return store.state.headerVisible
})
// 初始化消息处理器
initMessageHandler(store)

// 监听ws 消息
useConnectWebSocket(handleMessage)

function handleChangeCollapsed () {
  store.commit('SET_COLLAPSED', !collapsed.value)
}

function getClass () {
  let cls = ''
  if (
    root.$route.path.indexOf('/wayline-edit-planar') > -1 ||
    root.$route.path.indexOf('/wayline-edit') > -1 ||
    root.$route.path.indexOf('/wayline-edit-strip') > -1
  ) {
    cls += 'custom'
  }
  if (root.$route.path === '/wayline') {
    cls += ' custom-wayline'
  }
  if (!collapsed.value) cls += ' no-sidebar'
  return cls
}
function getStyle () {
  let sty = { width: '285px' }
  if (root.$route.path === '/wayline') {
    sty.width = '600px'
  }
  if (
    root.$route.path.indexOf('/wayline-edit-planar') > -1 ||
    root.$route.path.indexOf('/wayline-edit') > -1 ||
    root.$route.path.indexOf('/wayline-edit-strip') > -1
  ) {
    sty = {}
  }
  return sty
}
</script>
<style lang="scss" scoped>
@use "/@/styles/index.scss" as *;

.project-app-wrapper {
  display: flex;
  transition: width 0.2s ease;
  height: 100%;
  width: 100%;

  .left {
    position: relative;
    transition: width 0.2s ease-in-out;
    &:not(.custom) {
      &:not(.custom-wayline) {
      display: flex;
      width: 500px;
      flex: 0 0 335px;
      background-color: #2f2f2f;

      .main-content {
        flex: 1;
        color: $text-white-basic;
        // width: 285px;
      }
    }
    &:has(.custom-wayline){
      display: flex;
      width: 600px;
      flex: 0 0 335px;
      background-color: #2f2f2f;

      .main-content {
        flex: 1;
        color: $text-white-basic;
        // width: 285px;
      }
    }
    }
    &.no-sidebar .sidebar-container {
      width: 68px;
    }
    .menu-icon {
      width: 30px;
      height: 30px;
      padding: 10px;
      color: #f6f8fa;
      position: fixed;
      top: 15px;
      left: 280px;
      z-index: 1000;
      cursor: pointer;
      background-color: #02274b;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .right {
    flex-grow: 1;
    position: relative;

    .map-wrapper {
      width: 100%;
      height: 100%;
    }

    .media-wrapper,
    .task-wrapper,
    .device-wrapper {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 400;
      background: #f6f8fa;
    }
  }
}
</style>
